// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cohort-analysis {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 2.5rem auto;
  padding: 5rem 0;
}

.cohort-analysis .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 95%;
  margin-bottom: 0.5em;
}

.cohort-analysis .select-box {
  /* width: 95%; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
}

.cohort-analysis .select-box .ant-select-selector {
  min-width: 150px;
}

.cohort-analysis .table-div {
  width: 95%;
  background-color: white;
  padding: 20px 40px;
  border-radius: 0.75rem;
}

.cohort-analysis .table-div .months-row {
  display: flex;
  width: 93%;
}

.cohort-analysis .table-div .months-row .month-data {
  width: 8.3%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.cohort-analysis .table-div .months-row .month-data .month-name {
  width: 100%;
  border: 1px solid #eff9f6;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}

.cohort-analysis .table-div .months-row .month-data .month-name p {
  margin-bottom: 0;
}

.cohort-analysis .table-div .months-row .month-data .month-value {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  color: white;
  cursor: pointer;
  /* background: aqua; */
}

.cohort-shade1 {
  background: #ffff;
  color: #828e84 !important;
}

.cohort-shade2 {
  background: #d0d9c5;
  color: #828e84 !important;
}

.cohort-shade3 {
  background: #b2beb5;
}

.cohort-shade4 {
  background: #a9ba9d;
}

.cohort-shade5 {
  background: #828e84;
}
.cohort-shade6 {
  background: #687169;
}

.cohort-analysis .table-div .months-row .month-data .month-value p {
  margin-bottom: 0;
}

.cohort-analysis .table-div .months-col {
  width: 8.3%;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  flex-direction: column;
}

.cohort-analysis .table-div .months-col .month-name {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #eff9f6;
  height: 50px;
}

.cohort-analysis .table-div .months-col .month-name p {
  margin-bottom: 0;
}

.cohort-analysis .table-div .months-col .month-empty {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}

.cohort-analysis .cohort-campaign-planning {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 2.5rem auto;
  /* padding: 5rem 0; */
  width: 100%;
}

.cohort-analysis .cohort-campaign-planning .main-title {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  margin-bottom: 0.5em;
}

.cohort-analysis .cohort-campaign-planning .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 95%;
  margin-bottom: 1em;
}

.cohort-analysis .cohort-campaign-planning .title .modal-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
.cohort-analysis .cohort-campaign-planning .main-box {
  width: 95%;
  background-color: white;
  padding: 20px 40px;
  border-radius: 0.75rem;
  margin-bottom: 2rem;
}

.cohort-analysis .cohort-campaign-planning .main-box .cohort-campaign-table {
  padding: 20px 0;
}

.cohort-planning-table-btn {
  width: 50px;
  background: transparent;
  border: solid lightgray 1px;
  border-radius: 3px;
}

.cohort-planning-table-btn:hover {
  cursor: pointer;
  border: solid gray 1px;
}

.cohort-analysis .anatomy {
  width: 95%;
  background-color: white;
  padding: 40px;
  border-radius: 0.75rem;
}

.cohort-analysis .anatomy p {
  margin-bottom: 1rem;
  font-size: 16px;
  color: black;
  /* color: rgb(134, 172, 207); */
  /* font-style: italic; */
}

/* .cohort-analysis .cohort-campaign-planning .main-box .planning{
  display: flex;
  justify-content: space-between;
  margin: 2rem 0;
}

.cohort-analysis .cohort-campaign-planning .main-box .planning p{
  width: 70%;
}

.cohort-analysis .cohort-campaign-planning .main-box .planning .btn-container{
  display: flex;
  justify-content: space-between;
  width: 20%;
} */
`, "",{"version":3,"sources":["webpack://./src/styles/pages/CohortAnalysis.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;;GAcG","sourcesContent":[".cohort-analysis {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin: 2.5rem auto;\n  padding: 5rem 0;\n}\n\n.cohort-analysis .title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 95%;\n  margin-bottom: 0.5em;\n}\n\n.cohort-analysis .select-box {\n  /* width: 95%; */\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 20px;\n}\n\n.cohort-analysis .select-box .ant-select-selector {\n  min-width: 150px;\n}\n\n.cohort-analysis .table-div {\n  width: 95%;\n  background-color: white;\n  padding: 20px 40px;\n  border-radius: 0.75rem;\n}\n\n.cohort-analysis .table-div .months-row {\n  display: flex;\n  width: 93%;\n}\n\n.cohort-analysis .table-div .months-row .month-data {\n  width: 8.3%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.cohort-analysis .table-div .months-row .month-data .month-name {\n  width: 100%;\n  border: 1px solid #eff9f6;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n}\n\n.cohort-analysis .table-div .months-row .month-data .month-name p {\n  margin-bottom: 0;\n}\n\n.cohort-analysis .table-div .months-row .month-data .month-value {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n  color: white;\n  cursor: pointer;\n  /* background: aqua; */\n}\n\n.cohort-shade1 {\n  background: #ffff;\n  color: #828e84 !important;\n}\n\n.cohort-shade2 {\n  background: #d0d9c5;\n  color: #828e84 !important;\n}\n\n.cohort-shade3 {\n  background: #b2beb5;\n}\n\n.cohort-shade4 {\n  background: #a9ba9d;\n}\n\n.cohort-shade5 {\n  background: #828e84;\n}\n.cohort-shade6 {\n  background: #687169;\n}\n\n.cohort-analysis .table-div .months-row .month-data .month-value p {\n  margin-bottom: 0;\n}\n\n.cohort-analysis .table-div .months-col {\n  width: 8.3%;\n  display: flex;\n  /* justify-content: center; */\n  align-items: center;\n  flex-direction: column;\n}\n\n.cohort-analysis .table-div .months-col .month-name {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #eff9f6;\n  height: 50px;\n}\n\n.cohort-analysis .table-div .months-col .month-name p {\n  margin-bottom: 0;\n}\n\n.cohort-analysis .table-div .months-col .month-empty {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n}\n\n.cohort-analysis .cohort-campaign-planning {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin: 2.5rem auto;\n  /* padding: 5rem 0; */\n  width: 100%;\n}\n\n.cohort-analysis .cohort-campaign-planning .main-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 95%;\n  margin-bottom: 0.5em;\n}\n\n.cohort-analysis .cohort-campaign-planning .title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 95%;\n  margin-bottom: 1em;\n}\n\n.cohort-analysis .cohort-campaign-planning .title .modal-btn-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n}\n.cohort-analysis .cohort-campaign-planning .main-box {\n  width: 95%;\n  background-color: white;\n  padding: 20px 40px;\n  border-radius: 0.75rem;\n  margin-bottom: 2rem;\n}\n\n.cohort-analysis .cohort-campaign-planning .main-box .cohort-campaign-table {\n  padding: 20px 0;\n}\n\n.cohort-planning-table-btn {\n  width: 50px;\n  background: transparent;\n  border: solid lightgray 1px;\n  border-radius: 3px;\n}\n\n.cohort-planning-table-btn:hover {\n  cursor: pointer;\n  border: solid gray 1px;\n}\n\n.cohort-analysis .anatomy {\n  width: 95%;\n  background-color: white;\n  padding: 40px;\n  border-radius: 0.75rem;\n}\n\n.cohort-analysis .anatomy p {\n  margin-bottom: 1rem;\n  font-size: 16px;\n  color: black;\n  /* color: rgb(134, 172, 207); */\n  /* font-style: italic; */\n}\n\n/* .cohort-analysis .cohort-campaign-planning .main-box .planning{\n  display: flex;\n  justify-content: space-between;\n  margin: 2rem 0;\n}\n\n.cohort-analysis .cohort-campaign-planning .main-box .planning p{\n  width: 70%;\n}\n\n.cohort-analysis .cohort-campaign-planning .main-box .planning .btn-container{\n  display: flex;\n  justify-content: space-between;\n  width: 20%;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
